<template>
  <dashboard :msg="msg"/>
</template>

<script>
import { mapGetters } from "vuex";
import Dashboard from "../Dashboard"

export default {
  name: "Card-Success",
  components: {
    Dashboard
  },
  data: () => ({
    success_msg: {
      header: "Payment Successful",
      message: {
        text: "Your Payment was processed Successfully",
        color: "success",
      },
      routename: "home",
      routemsg: "Go to Home Page"
    },
    
    cancel_msg: {
      header: "Payment Canceled",
      message: {
        text: "Your Payment was not processed",
        color: "warning",
      },
      routename: "profile",
      routemsg: "Profile Page"
    },
  }),
  computed: {
    msg() {
      if (this.$route.query.processed === undefined){
        return undefined
      } else {
        console.log(this.$route.query.processed)
        if (this.$route.query.processed == "true") {
          return this.success_msg 
        } else {
          return this.cancel_msg
        }
      }
    },
    ...mapGetters({
      user: "user"
    })
  }
}
</script>